import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/apps/pauljohnson/src/app/_media/paul-headshot-small.png");
;
import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/packages/ui-web/src/accordion/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/packages/ui-web/src/accordion/card-accordion.tsx");
;
import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/packages/ui-web/src/avatar/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/packages/ui-web/src/backgrounds/sparkles.tsx");
;
import(/* webpackMode: "eager" */ "/home/brian/actions-runner/_work/streetferret-app/streetferret-app/packages/ui-web/src/button/confetti-button.tsx");
